
















import { Component, Prop, Watch } from 'vue-property-decorator';
import CreateListDataMixin, { FilterGetterFn } from '@/mixin/ListDataMixin';
import { IssueCommentEntity } from '@/entities/issue-comment.entity';
import { mixins } from 'vue-class-component';
import IssueItemBaseMixin from '@/components/ViewComponent/Issue/IssueItem/issue-item-base.mixin';
import IssueCommentItem from '@/components/ViewComponent/Issue/IssueDetail/IssueCommentItem.vue';
import BorderCard from '@/components/Helper/Card/BorderCard.vue';

const filter: FilterGetterFn = (el: IssueCommentsPc) => [['issueId', '$eq', el.issue.id]];
const join = [
  'commenter',
  'reactions',
  'reactions.emoticon',
];
const order: [string, 'DESC' | 'ASC'][] = [['createdAt', 'DESC']];

@Component<IssueCommentsPc>({
  components: { BorderCard, IssueCommentItem },
})
export default class IssueCommentsPc extends mixins(
  CreateListDataMixin<IssueCommentEntity>(
    'issue-comment',
    'issue_comment',
    join,
    order,
    20,
    filter,
  ),
  IssueItemBaseMixin,
) {
  endLoad = false;

  @Prop({ type: HTMLDivElement })
  containerRef: HTMLDivElement;

  get comments() {
    return this.items;
  }

  @Watch('containerRef')
  handleChangeContainerRef(val) {
    if (val) val.addEventListener('scroll', this.handleScroll);
  }

  destroyed() {
    this.containerRef.removeEventListener('scroll', this.handleScroll);
  }

  async handleScroll(e) {
    if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight && !this.endLoad) {
      this.loading = true;
      let rows;
      [rows, , this.endOfPage] = await this.apiStore.nextPage().getMany();
      this.rawItems = [...this.rawItems, ...rows];
      this.loading = false;
      if (!rows.length) this.endLoad = true;
    }
  }

  mounted() {
    this.$cheeers.socket.on('issue_comment_created', (data: IssueCommentEntity) => {
      const issueId = Number(this.$route.params.id);
      if (issueId === data.issueId) {
        this.prependItem(data.id);
      }
    });
  }
}
